const ACUITY_CUSTOMER_PARAMS = new Set([
  'firstName',
  'lastName',
  'email',
  'phone',
]);

export const POSTAL_CODE_FIELD = 'field:4339120';

export function normalizePostalCode(value = '') {
  return value.toUpperCase().replace(/[^A-Z0-9]/g, '');
}

export function isValidCanadianPostalCode(value) {
  return /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTVWXYZ][0-9][ABCEGHJ-NPRSTVWXYZ][0-9]$/.test(
    normalizePostalCode(value)
  );
}

export function getPrefilledPostalCode(search) {
  const params = new URLSearchParams(search);
  return normalizePostalCode(
    params.get('postalCode') || params.get(POSTAL_CODE_FIELD) || ''
  );
}

function isAcuityCustomerParam(name) {
  return (
    ACUITY_CUSTOMER_PARAMS.has(name) ||
    /^field:\d+(?:\[\])?$/.test(name)
  );
}

export function buildAcuityRedirectUrl(acuityUrl, search, postalCode) {
  const destination = new URL(acuityUrl);
  const incoming = new URLSearchParams(search);
  const customerParamNames = new Set();

  incoming.forEach((_value, name) => {
    if (isAcuityCustomerParam(name)) {
      customerParamNames.add(name);
    }
  });

  customerParamNames.forEach((name) => {
    const values = incoming.getAll(name).filter((value) => value !== '');
    if (values.length === 0) {
      return;
    }

    destination.searchParams.delete(name);
    values.forEach((value) => destination.searchParams.append(name, value));
  });

  const suppliedPostalCode = incoming
    .getAll(POSTAL_CODE_FIELD)
    .some((value) => value !== '');
  const hasSchedulingPrefill =
    incoming.has('postalCode') || customerParamNames.size > 0;

  if (!suppliedPostalCode && hasSchedulingPrefill && postalCode) {
    destination.searchParams.set(
      POSTAL_CODE_FIELD,
      normalizePostalCode(postalCode)
    );
  }

  return destination.toString();
}
